<template>
  <v-dialog :value="$store.state.doc.show" width="1000" @input="$store.commit('doc/setShow', false)">
    <v-card flat>
      <v-container>
        <v-toolbar flat>
          <v-toolbar-title>
            {{ $t('Help.Doc.header') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-row>
          <v-col cols="5">
            <v-card flat style="overflow-y: auto;" height="500">
              <v-list-item-group v-model="panel" color="primary" >
                <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <v-list-item-icon>
                    <v-icon>help_center</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-card>
            
          </v-col>
          <v-col cols="7">
            <v-slide-x-transition mode="out-in">
              <v-card v-if="selectedItem" :key="'doc_' + panel" height="">
                <v-card-text v-html="selectedItem.text" />
                <v-img 
                  v-if="selectedItem.src" 
                  :src="require('@/assets/help/' + selectedItem.src)" 
                  max-height="400"
                  contain
                ></v-img>
              </v-card>
              <v-card v-else class="text-center" flat>
                <v-icon size="250" class="mt-10">
                  help_outline
                </v-icon>
              </v-card>
            </v-slide-x-transition>
          </v-col>
        </v-row>
        
      </v-container>
    </v-card>
  </v-dialog>
  
</template>

<script>
import { doc } from '@/config/help'
import { mapGetters } from 'vuex'
export default {
  name: 'HelpDoc',
  data: () => ({
    panel: null
  }),
  computed: {
    ...mapGetters('auth', [
      'isAdmin'
    ]),
    selectedItem () {
      return this.items[this.panel] || null
    },
    items () {
      return doc.map((item, index) => ({
        ...item,
        title: this.$t('Help.Doc.title_' + (index + 1)),
        text: this.$t('Help.Doc.text_' + (index + 1))
      }))
      .filter(item => this.isAdmin || !item.isAdmin)
    }
  }
}
</script>

<style>

</style>